/**
 * @generated SignedSource<<2ccdd67fce3363ad25f97c0a84a6a44c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type BillSendSmsInput = {
  bill: string;
};
export type BillSendMessageDialog_billSendMessageMutation$variables = {
  input: BillSendSmsInput;
};
export type BillSendMessageDialog_billSendMessageMutation$data = {
  readonly billSendMessage: {
    readonly id: string;
  };
};
export type BillSendMessageDialog_billSendMessageMutation = {
  response: BillSendMessageDialog_billSendMessageMutation$data;
  variables: BillSendMessageDialog_billSendMessageMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "Bill",
    "kind": "LinkedField",
    "name": "billSendMessage",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "BillSendMessageDialog_billSendMessageMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BillSendMessageDialog_billSendMessageMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "fe55f7b3b9afa235ef93a8e76a2ea3aa",
    "id": null,
    "metadata": {},
    "name": "BillSendMessageDialog_billSendMessageMutation",
    "operationKind": "mutation",
    "text": "mutation BillSendMessageDialog_billSendMessageMutation(\n  $input: BillSendSmsInput!\n) {\n  billSendMessage(input: $input) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "3297a65eb06be626edb99e97fe964312";

export default node;
